import React from 'react'

import MuteIcon from '../../../components/icons/mute'
import UnmuteIcon from '../../../components/icons/unmute'
import styles from './muteSwitcher.module.css'

const MuteSwitcher = ({
  muted,
  onMute = () => {},
  onUnmute = () => {}
}) => (
  <div>
    { muted
      ? <span className={styles.iconContainer} onClick={onUnmute}>
        <MuteIcon width='14' height='14' />
        <span className={styles.iconLabel}>Unmute</span>
      </span>
      : <span className={styles.iconContainer} onClick={onMute}>
        <UnmuteIcon width='14' height='14' />
        <span className={styles.iconLabel}>Mute</span>
      </span>
    }
  </div>
)

export default MuteSwitcher



// WEBPACK FOOTER //
// ./client/pages/search/result/muteSwitcher.js